import { render, staticRenderFns } from "./PlantillaLogin.vue?vue&type=template&id=5f15ecee&scoped=true&"
import script from "./PlantillaLogin.vue?vue&type=script&lang=js&"
export * from "./PlantillaLogin.vue?vue&type=script&lang=js&"
import style0 from "./PlantillaLogin.vue?vue&type=style&index=0&id=5f15ecee&scoped=true&lang=css&"
import style1 from "./PlantillaLogin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f15ecee",
  null
  
)

export default component.exports